import { Stack } from '@chakra-ui/react'
import { InputFormControl, SelectFormControl } from 'BrokerTsLib/src/components'
import type { EditOrganizationUnit } from 'BrokerTsLib/src/dtos'
import { DealerTypes } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

import { SwitchableFormSection } from '@/components'
import type { FormSectionProps } from '@/containers/forms/FormSection'

export const OrganizationMotivationFormSection = forwardRef(
  function OrganizationMotivationFormSection(props: FormSectionProps, ref: Ref<HTMLDivElement>) {
    const { register, control, watch } = useFormContext<EditOrganizationUnit>()

    const enabled = watch('properties.ouMotivation.motivationYesNo')

    return <SwitchableFormSection ref={ref} sectionTitle='Zařazení' register={register('properties.ouMotivation.motivationYesNo')} {...props}>
      <Stack gap={6}>
        <SelectFormControl label='Dealer RCI/UCL'
          options={DealerTypes.map(([type, name]) => ({
            value: type,
            label: name
          }))}
          unselectedText="Vyberte typ dealera"
          name="properties.ouMotivation.dealerType" control={control} isRequired={enabled} />

        <InputFormControl label="Pobočka UCL"
          name="properties.ouMotivation.branchUcl" control={control} isRequired={enabled} />

        <InputFormControl label="Obchodník"
          name="properties.ouMotivation.trader" control={control} isRequired={enabled} />
      </Stack>
    </SwitchableFormSection>
  }
)